import 'lazysizes';

import './sass/app.scss';

import moment from 'moment-timezone';

moment.tz.setDefault(window.app.timeZone);

$.ajaxSetup({
    beforeSend: (jqXHR: JQuery.jqXHR, settings: JQuery.AjaxSettings): void => {
        if (settings.url.substr(0, 1) === '/') {
            settings.url = window.app.baseUrl + settings.url;
        }
    },
});

import './ts/app';
